<template>
	<b-modal  ok-only centered size="lg" class="modal fade modal-fullscreen-lg-down" id="ModalContact" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-fullscreen-lg-down modal-lg">
			<img class="map" src="../assets/img/fig-contact.jpg">    

			<div class="">
				<p class="center">
					<h1 class="center"><span class="prix">Mon Parcours</span></h1>
					<hr/>
				</p>
				<p class="modalcontact">
J'ai réellement adoré diriger le centre de formation que j'ai créé il y a 20 ans.<br>
Aujourd'hui, souhaitant redéfinir mes essentiels et donner un nouveau rythme à mes journées, je suis devenue sophrologue à l'issue d'un cursus de deux ans au CEAS Paris.<br>
J'accompagne et aide particuliers et entreprises dans une démarche personnalisée autour du mieux-être pour soi et pour les autres.<br>
Membre de la chambre syndicale de la sophrologie dont je partage le code de déontologie, je vous recevrai avec toute mon attention à mon cabinet, sur rendez vous.<br><br>
A bientôt !
				</p>

			</div>
		</div>
	</b-modal>

</template>

<script>
export default {}
</script>

<style scoped>
.modalcontact{
	text-align: left!important;
	padding:15px;
}


</style>
